// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"39f74ecc22b34eaa93c0","132":"16b1c02b2c3699f34199","133":"02ead2a67eeae514975d","180":"8982e92e5ff0ff4cc9f1"}[chunkId] + ".chunk.js";
};